import { render, staticRenderFns } from "./ReportRequests.vue?vue&type=template&id=4a46dbf8&scoped=true"
import script from "./ReportRequests.ts?vue&type=script&lang=ts&external"
export * from "./ReportRequests.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportRequests.scss?vue&type=style&index=0&id=4a46dbf8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46dbf8",
  null
  
)

export default component.exports